import { useContext } from 'react';

import { PortalConfigContext, useFeatureFlags } from 'src/context';

/**
 * True only when Studio FTUX should show: the `studioFTUX` flag is on *and* the
 * workspace is a Studio workspace. Every FTUX surface (sidebar checklists, CRM
 * coachmark tour, portal-intercept and post-publish modals) gates on this pair,
 * so centralizing it keeps a surface from shipping with only half the gate.
 */
export const useIsStudioUser = (): boolean => {
  const { EnableStudioFTUX } = useFeatureFlags();
  const { isStudioUser } = useContext(PortalConfigContext);

  return Boolean(EnableStudioFTUX && isStudioUser);
};
